import { render, staticRenderFns } from "./social-sign.vue?vue&type=template&id=ea008204&scoped=true"
import script from "./social-sign.vue?vue&type=script&lang=js"
export * from "./social-sign.vue?vue&type=script&lang=js"
import style0 from "./social-sign.vue?vue&type=style&index=0&id=ea008204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea008204",
  null
  
)

export default component.exports